import React from 'react';
import { HomeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';

export function HomeLink({ className }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <Link to='/' className={['site-home-link', className].filter(Boolean).join(' ')}>
      <HomeOutlined />
      <span>{t('common.home')}</span>
    </Link>
  );
}
